import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Image } from "../../Image/index.js";
import { ModuleLayout } from "../Layout/ModuleLayout.js";
import { logoCloudVariants } from "./ModuleLogoCloud.variants.js";
const ModuleLogoCloud_ModuleLogoCloud = /*#__PURE__*/ forwardRef(function({ logos, children, maxColumns, ...sectionProps }, ref) {
    const { grid } = logoCloudVariants({
        maxColumns
    });
    const defaultContent = /*#__PURE__*/ jsx("div", {
        className: grid(),
        children: logos.map((logo)=>/*#__PURE__*/ jsx(Image, {
                src: logo.src,
                alt: logo.alt,
                isSvg: true,
                height: 20,
                maxWidth: "full",
                objectFit: "contain"
            }, logo.src))
    });
    return /*#__PURE__*/ jsx(ModuleLayout, {
        ref: ref,
        ...sectionProps,
        children: children ?? defaultContent
    });
});
export { ModuleLogoCloud_ModuleLogoCloud as ModuleLogoCloud };
